import React from "react";
import CommonPopup from "..";
import CommonButton from "../../Button";

type Props = { popup: string; onClose?: () => void };

export default function CertEmailPopup({ popup, onClose }: Props) {
  return (
    <CommonPopup isOpen={popup === "certEmail"} title="이메일 인증" padding={0}>
      <div>
        <div className="p-5 pt-0">
          <div className="py-2.5 flex flex-col gap-2.5 items-center">
            <EmailVerifyPopupBanner />

            <div className=" whitespace-pre-line text-center text-brand-neutral-60 text-sm">
              {
                "입력하신 이메일 주소로\n샌디 확인 메일이 발송됩니다.\n메일함을 확인해주세요."
              }
            </div>
          </div>
        </div>
        <CommonButton
          className="w-full rounded-none h-bottom-button"
          onClick={onClose}
        >
          확인
        </CommonButton>
      </div>
    </CommonPopup>
  );
}

export const EmailVerifyPopupBanner = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="60" height="60" fill="white" />
    <path
      d="M54 25L30 4L6 25V56H54V25Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask id="path-2-inside-1_1357_39819" fill="white">
      <rect x="12" y="13" width="36" height="40" rx="1" />
    </mask>
    <rect
      x="12"
      y="13"
      width="36"
      height="40"
      rx="1"
      fill="white"
      stroke="black"
      strokeWidth="4"
      mask="url(#path-2-inside-1_1357_39819)"
    />
    <path
      d="M29.248 30.9883C27.5195 30.9785 26.123 29.6211 26.123 27.0234C26.123 24.3672 27.5879 23.0879 29.248 23.0781C30.4297 23.0879 31.084 23.791 31.3574 24.3867H31.4355V23.293H33.5449V28.2344C33.5645 28.8594 33.7988 29.1621 34.2871 29.1523C35.1758 29.1621 35.7422 28.1367 35.752 26.5352C35.752 23.2832 33.4863 21.1445 30.0098 21.1445C26.5137 21.1445 24.2676 23.5957 24.2676 27.0234C24.2676 30.7051 26.2305 32.9414 29.9707 32.9219C31.3672 32.9219 32.4805 32.7852 33.5449 32.5117V34.543C32.5 34.8652 31.2695 35.0312 29.9707 35.0312C25.0098 35.0312 22.1777 31.877 22.1777 27.0234C22.1777 22.3945 25.4102 19.0352 30.0098 19.0352C34.6094 19.0352 37.832 22.1699 37.8223 26.4766C37.8223 29.4062 36.3574 31.0859 34.0723 31.0859C32.7344 31.0664 31.7285 30.4805 31.4941 29.6211H31.416C31.1328 30.2266 30.4688 30.9785 29.248 30.9883ZM28.5645 27.0234C28.5547 28.2051 29.082 29.0059 30.0098 28.9961C30.9668 29.0059 31.4844 28.2344 31.4941 27.0234C31.4844 25.8125 30.9668 25.0605 30.0098 25.0508C29.082 25.0605 28.5547 25.8516 28.5645 27.0234Z"
      fill="black"
    />
    <path
      d="M22 40L6 25V56H22V40Z"
      fill="white"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 40L54 25V56H38V40Z"
      fill="white"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3191 41L6 56H54L38.6596 41C37 39.5 33.166 38 29.4894 38C25.8128 38 23 39.5 21.3191 41Z"
      fill="white"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
